import imgAns from '../../../../assets/ans_logo_vert.gif';

export default [
  {
    name: 'link/ans',
    path: '/link/ans',
    beforeEnter() { location.href = 'http://www.ans.gov.br'; },
    meta: {
      requiresAuth: true,
      breadcrum: 'ANS',
      icon: 'link', // http://www.ans.gov.br/aans/quem-somos/selo-ans
      can: 'list',
      on: 'links',
      logo: imgAns,
      // newTab: true,
    },
  },
];
